/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Button, Col, FormGroup, Row } from 'reactstrap';

import { connect } from 'react-redux';

import { change, Field, Form, formValueSelector, reduxForm } from 'redux-form';

import Table from 'react-table';

import FormItem from '../../../common/forms/FormItem';

import TextInput from '../../../common/forms/input/TextInput';

import FormFooter from '../../../common/forms/FormFooter';

import SelectionableTable from '../../../common/forms/table/SelectionableTable';

import { getManualVoucherBySeriesAndDocumentCode } from '../../../../actions/accounting/ManualVoucher';

import {
  clearManualVoucherPaymentReconciliation,
  getManualVoucherPaymentReconciliation,
} from '../../../../actions/corporate/ManualVoucherPayment';

import { MANUAL_VOUCHER_RECONCILIATION_PAYMENT_COLUMNS } from '../../../../config/columns';

import { numberFormatter } from '../../../../utils/number';

const FORM_NAME = 'ManualVoucherPaymentReconciliationForm';

export const ManualVoucherPaymentReconciliationForm = ({
  handleSubmit,
  dispatchChange,
  dispatchGetManualVoucherBySeriesAndDocumentCode,
  dispatchGetManualVoucherPaymentReconciliation,
  dispatchClearManualVoucherPaymentReconciliation,
  documentSeries,
  documentCode,
  manualVoucherId,
  selectedPaymentIds,
  reconciliation,
  loading,
}) => {
  const [manualVoucher, setManualVoucher] = useState(null);

  const [searchingVoucher, setSearchingVoucher] = useState(false);

  const reconciliationJson =
    reconciliation && reconciliation.toJS
      ? reconciliation.toJS()
      : reconciliation || {};

  const {
    availablePayments = [],
    reconciledPayments = [],
    totalAmount = 0,
    reconciledAmount = 0,
    remainingAmount = 0,
    currencyCode,
  } = reconciliationJson;

  const clearReconciliation = () => {
    setManualVoucher(null);

    dispatchChange(FORM_NAME, 'manualVoucherId', null);

    dispatchChange(FORM_NAME, 'selectedPaymentIds', null);

    dispatchClearManualVoucherPaymentReconciliation();
  };

  const clearVoucherSearchFields = () => {
    dispatchChange(FORM_NAME, 'documentSeries', null);

    dispatchChange(FORM_NAME, 'documentCode', null);
  };

  const handleVoucherSearchFieldChange = () => {
    if (manualVoucherId) {
      clearReconciliation();
    }
  };

  const searchManualVoucher = async () => {
    if (!documentSeries || !documentCode || searchingVoucher) {
      return;
    }

    try {
      setSearchingVoucher(true);

      const response = await dispatchGetManualVoucherBySeriesAndDocumentCode({
        documentSeries,
        documentCode,
      });

      if (!response) {
        clearReconciliation();

        return;
      }

      setManualVoucher(response);

      dispatchChange(FORM_NAME, 'manualVoucherId', response.id);

      dispatchChange(FORM_NAME, 'selectedPaymentIds', null);

      await dispatchGetManualVoucherPaymentReconciliation({
        manualVoucherId: response.id,
      });
    } finally {
      setSearchingVoucher(false);
    }
  };

  const clearVoucherSearch = () => {
    clearReconciliation();

    clearVoucherSearchFields();
  };

  const selectedAmount = availablePayments
    .filter((payment) => (selectedPaymentIds || []).includes(payment.id))
    .reduce((total, payment) => total + Number(payment.amount || 0), 0);

  const remainingAfterReconciliation = Number(remainingAmount) - selectedAmount;

  return (
    <Form onSubmit={handleSubmit}>
      <h4>Buscar Comprobante Manual</h4>

      <p className="text-muted">
        Busque el comprobante que desea conciliar utilizando la serie y el
        correlativo.
      </p>

      {!manualVoucherId && (
        <Row>
          <Col lg={4} md={4} sm={12}>
            <FormGroup>
              <FormItem label="Serie">
                <Field
                  name="documentSeries"
                  component={TextInput}
                  placeholder="Ej. F919"
                  disabled={searchingVoucher}
                  onChange={handleVoucherSearchFieldChange}
                />
              </FormItem>
            </FormGroup>
          </Col>

          <Col lg={4} md={4} sm={12}>
            <FormGroup>
              <FormItem label="Correlativo">
                <Field
                  name="documentCode"
                  component={TextInput}
                  placeholder="Ej. 2139"
                  disabled={searchingVoucher}
                  onChange={handleVoucherSearchFieldChange}
                />
              </FormItem>
            </FormGroup>
          </Col>

          <Col lg={4} md={4} sm={12} className="d-flex align-items-center">
            <Button
              type="button"
              color="primary"
              outline
              disabled={!documentSeries || !documentCode || searchingVoucher}
              onClick={searchManualVoucher}
            >
              {searchingVoucher ? (
                <>
                  <i className="fa fa-spinner fa-spin" /> Buscando...
                </>
              ) : (
                <>
                  <i className="fa fa-search" /> Buscar comprobante
                </>
              )}
            </Button>
          </Col>
        </Row>
      )}

      <Field name="manualVoucherId" component="input" type="hidden" />

      {manualVoucher && (
        <>
          <div className="alert alert-success">
            <Row>
              <Col md={10}>
                <h5>Comprobante encontrado</h5>

                <div>
                  <strong>Comprobante: </strong>
                  {manualVoucher.documentSeries}-{manualVoucher.documentCode}
                </div>

                {manualVoucher.voucherType && (
                  <div>
                    <strong>Tipo: </strong>

                    {manualVoucher.voucherType.name}
                  </div>
                )}

                {manualVoucher.business && (
                  <>
                    <div>
                      <strong>Empresa: </strong>

                      {manualVoucher.business.name}
                    </div>

                    <div>
                      <strong>RUC: </strong>

                      {manualVoucher.business.businessTaxId}
                    </div>
                  </>
                )}

                {manualVoucher.customer && (
                  <>
                    <div>
                      <strong>Persona Natural: </strong>

                      {manualVoucher.customer.fullName}
                    </div>

                    <div>
                      <strong>Documento: </strong>

                      {manualVoucher.customer.idDocumentNumber}
                    </div>
                  </>
                )}

                <div>
                  <strong>Moneda: </strong>

                  {currencyCode || manualVoucher.currencyCode}
                </div>
              </Col>

              <Col md={2} className="text-right">
                <Button
                  type="button"
                  color="danger"
                  outline
                  size="sm"
                  disabled={loading || searchingVoucher}
                  onClick={clearVoucherSearch}
                >
                  <i className="fa fa-times" /> Quitar
                </Button>
              </Col>
            </Row>
          </div>

          <Row>
            <Col md={4}>
              <div className="alert alert-info">
                <strong>Monto del comprobante</strong>

                <br />

                {numberFormatter({
                  currency: currencyCode || manualVoucher.currencyCode,
                  value: totalAmount,
                })}
              </div>
            </Col>

            <Col md={4}>
              <div className="alert alert-info">
                <strong>Monto conciliado</strong>

                <br />

                {numberFormatter({
                  currency: currencyCode || manualVoucher.currencyCode,
                  value: reconciledAmount,
                })}
              </div>
            </Col>

            <Col md={4}>
              <div className="alert alert-info">
                <strong>Saldo pendiente</strong>

                <br />

                {numberFormatter({
                  currency: currencyCode || manualVoucher.currencyCode,
                  value: remainingAmount,
                })}
              </div>
            </Col>
          </Row>

          <hr />

          <h4>Pagos Conciliados</h4>

          <p className="text-muted">
            Pagos que actualmente se encuentran asociados al comprobante.
          </p>

          <Table
            data={reconciledPayments}
            columns={MANUAL_VOUCHER_RECONCILIATION_PAYMENT_COLUMNS}
            defaultPageSize={10}
            minRows={0}
            showPagination={reconciledPayments.length > 10}
            className="-striped -highlight"
          />

          <hr />

          <h4>Pagos Disponibles</h4>

          <p className="text-muted">
            Seleccione uno o varios pagos para asociarlos al comprobante.
          </p>

          <SelectionableTable
            form={FORM_NAME}
            name="selectedPaymentIds"
            data={availablePayments}
            columns={MANUAL_VOUCHER_RECONCILIATION_PAYMENT_COLUMNS}
            keyField="id"
            returnOnlySelectedItems
            shouldResetSelection
            showSelectAll
            required
            filterable={false}
            defaultPageSize={10}
            loading={loading}
            disabled={loading || searchingVoucher}
            blockEnterSubmit
          />

          <hr />

          <Row>
            <Col md={4}>
              <div>
                <strong>Saldo pendiente:</strong>{' '}
                {numberFormatter({
                  currency: currencyCode,
                  value: remainingAmount,
                })}
              </div>
            </Col>

            <Col md={4}>
              <div>
                <strong>Total seleccionado:</strong>{' '}
                {numberFormatter({
                  currency: currencyCode,
                  value: selectedAmount,
                })}
              </div>
            </Col>

            <Col md={4}>
              <div>
                <strong>Saldo después:</strong>{' '}
                {numberFormatter({
                  currency: currencyCode,
                  value: remainingAfterReconciliation,
                })}
              </div>
            </Col>
          </Row>

          {remainingAfterReconciliation < 0 && (
            <div className="alert alert-danger mt-3">
              Los pagos seleccionados superan el saldo pendiente del
              comprobante.
            </div>
          )}

          <FormFooter
            saveButtonDisabled={
              loading ||
              searchingVoucher ||
              !selectedPaymentIds ||
              selectedPaymentIds.length === 0 ||
              remainingAfterReconciliation < 0
            }
          />
        </>
      )}
    </Form>
  );
};

ManualVoucherPaymentReconciliationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,

  dispatchChange: PropTypes.func.isRequired,

  dispatchGetManualVoucherBySeriesAndDocumentCode: PropTypes.func.isRequired,

  dispatchGetManualVoucherPaymentReconciliation: PropTypes.func.isRequired,

  dispatchClearManualVoucherPaymentReconciliation: PropTypes.func.isRequired,

  documentSeries: PropTypes.string,

  documentCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  manualVoucherId: PropTypes.number,

  selectedPaymentIds: PropTypes.arrayOf(PropTypes.number),

  reconciliation: PropTypes.shape({}),

  loading: PropTypes.bool,
};

ManualVoucherPaymentReconciliationForm.defaultProps = {
  documentSeries: null,
  documentCode: null,
  manualVoucherId: null,
  selectedPaymentIds: null,
  reconciliation: null,
  loading: false,
};

const validate = (values) => {
  const errors = {};

  if (!values.manualVoucherId) {
    errors.manualVoucherId = 'Debe buscar un comprobante manual';
  }

  if (
    values.manualVoucherId &&
    (!values.selectedPaymentIds || values.selectedPaymentIds.length === 0)
  ) {
    errors.selectedPaymentIds = 'Debe seleccionar al menos un pago';
  }

  return errors;
};

const selector = formValueSelector(FORM_NAME);

const mapStateToProps = (state) => ({
  documentSeries: selector(state, 'documentSeries'),

  documentCode: selector(state, 'documentCode'),

  manualVoucherId: selector(state, 'manualVoucherId'),

  selectedPaymentIds: selector(state, 'selectedPaymentIds'),

  reconciliation: state.CorporateUnit.ManualVoucherPayment.getIn([
    'reconciliation',
    'content',
  ]),

  loading: state.CorporateUnit.ManualVoucherPayment.getIn([
    'reconciliation',
    'loading',
  ]),
});

const mapDispatchToProps = {
  dispatchChange: change,

  dispatchGetManualVoucherBySeriesAndDocumentCode:
    getManualVoucherBySeriesAndDocumentCode,

  dispatchGetManualVoucherPaymentReconciliation:
    getManualVoucherPaymentReconciliation,

  dispatchClearManualVoucherPaymentReconciliation:
    clearManualVoucherPaymentReconciliation,
};

const formComponent = reduxForm({
  form: FORM_NAME,

  validate,

  initialValues: {
    manualVoucherId: null,
    selectedPaymentIds: null,
  },
})(ManualVoucherPaymentReconciliationForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
